import { useEffect, useState } from "react";

export function useDelayedRender(delayInMilliseconds: number) {
  const [delayed, setDelayed] = useState(true);
  useEffect(() => {
    const timeout = setTimeout(() => setDelayed(false), delayInMilliseconds);
    return () => clearTimeout(timeout);
  }, [delayInMilliseconds]);
  return (fn: () => JSX.Element): JSX.Element | null =>
    (!delayed && fn()) || null;
}
